'use client';

import { createContext, useContext, useMemo, PropsWithChildren } from 'react';

type UserAgentContextType = {
  isWebView: boolean;
  isAndroid: boolean;
  isIos: boolean;
  userAgent: string;
  origin: string;
};

const UserAgentContext = createContext<UserAgentContextType>({
  isWebView: false,
  isAndroid: false,
  isIos: false,
  userAgent: '',
  origin: ''
});

export function UserAgentProvider({
  children,
  userAgent,
  origin
}: PropsWithChildren<{ userAgent: string; origin: string }>) {
  const value = useMemo(() => {
    const ua = userAgent.toLowerCase();
    const androidWebView = /android/.test(ua) && /wv/.test(ua);
    const iosWebView = /ip(hone|od|ad)/.test(ua) && !/safari/.test(ua);

    return {
      isWebView: androidWebView || iosWebView,
      isAndroid: /android/.test(ua),
      isIos: /ip(hone|od|ad)/.test(ua),
      userAgent: ua,
      origin
    };
  }, [userAgent, origin]);

  return (
    <UserAgentContext.Provider value={value}>
      {children}
    </UserAgentContext.Provider>
  );
}

export const useUserAgentContext = () => useContext(UserAgentContext);
